<template>

  <div class="details-component">
    <div class="details-component__header" v-on:click="toggleSection">
      <h1 class="header">{{ $t('product.guestParking') }}</h1>
      <div class="details-component__header_right">
        <div :class="!showSection ? toggleIconDown : toggleIconUp" />
      </div>
    </div>

    <div v-if="!this.isLoading">
      <div class="parking" v-if="parkings.length > 0">
        <div v-show="showSection">
          <div class="number-change">
            <el-input id="vehicleReg" name="vehicleReg" class="el-input__inner--vehicle-reg" v-model="form.vehicleReg"
              :placeholder="$t('parking.vehicleReg')" @keyup.enter.native="addVehicleRegToCookies()"
              @blur="addVehicleRegToCookies()" @clear="addVehicleRegToCookies()" @focus="focusedVehicleReg"
              clearable></el-input>
            <tooltip v-show="vehicleRegError" ref="tooltip" class="vehicleReg-tooltip">{{
              $t('errors.car_field_required')
            }}
            </tooltip>
          </div>

          <!-- desktop version -->

          <table class="parking__table" v-if="window.width > 760">
            <tr class="parking__row parking-details-container" v-for="(parking, index) in parkings" :key="index"
              :class="parking.parkings.length > 0 ? 'active-parking' : ''">
              <td class="parking__col parking-name-container" style="padding-left: 10px">
                <div class="parking__text d-flex">
                  <div v-if="user.paymentModuleEnabled">
                    <div v-if="parking.payment_required" class="payment-requirement paid">
                      <i class="parking__icon icon-parking-paid"></i>
                    </div>
                    <div v-else class="payment-requirement free">
                      <i class="parking__icon icon-parking-free"></i>
                    </div>
                  </div>
                  <div v-else>
                    <div class="payment-requirement free">
                      <i class="parking__icon icon-parking-free"></i>
                    </div>
                  </div>
                </div>
                <div class="parking__text">{{ parking.name }}</div>
              </td>
              <td class="parking__col occupancy-cell">
                <div class="occupancy-data-container">
                  <div class="occupancy-details">
                    <div class="occupancy-details-container sessions-count">
                      <div class="sessions-count-icon"></div>{{ parking.active_sessions_count }}
                    </div>
                    <div v-if="parking.max_sessions" class="occupancy-details-container max-sessions">
                      <div class="max-sessions-icon"></div>{{ parking.max_sessions }}
                    </div>
                  </div>
                </div>
                <!-- {{ parking }} -->
              </td>
              <td class="parking__col parking__col--buttons parking-button-container" style="padding-right: 10px; ">

                <!-- running guest parking -->

                <div v-if="parking.parkings.length > 0">
                  <div v-for="(parked, p_index) in parking.parkings" :key="p_index">
                    <div class="parking-info d-flex">
                      <div class="d-flex">
                        <div class="car-number">
                          <div class="icon-car-grey"></div>
                          <div>{{ parked.vehicle_reg }}</div>
                        </div>
                        <div class="parking-clock">
                          <div class="icon-clock-grey"></div>
                          <div style="white-space: nowrap">{{ getTime(parked.start_time) }} >>
                            {{ getTime(parked.end_time) }}
                          </div>
                        </div>
                        <tooltip2 :id="'tlt-da-' + index" :ref="'tlt-da-' + index" class="tooltip2"
                          style="visibility: hidden">
                          <PricingRulesInfo :price-rules="parking.pricing_rules" />
                        </tooltip2>
                        <div v-if="parking.payment_required" class="parking-clock"
                          @click="showTooltip('tlt-da-' + index)">
                          <div class="icon-card-grey"></div>
                          <ParkingCostInfo :price-rules="parking.pricing_rules" :active-parking="parking.parkings" />

                          <div class="icon-info-circle"></div>
                        </div>
                      </div>
                      <el-button class="parking__button el-button btn parking__button-stop el-button--danger"
                        @click="confirmToStopGuestParking(parked.id, parking.id)">
                        <span class="icon-parking-stop-w">{{ $t('end_user.stopParking') }}</span>
                      </el-button>
                    </div>
                  </div>
                </div>

                <!-- not started guest parking -->

                <div v-else class="parking-info d-flex">
                  <tooltip2 :id="'tlt-d-' + index" :ref="'tlt-' + index" class="tooltip2" style="visibility: hidden">
                    <PricingRulesInfo :price-rules="parking.pricing_rules" />
                  </tooltip2>
                  <div v-if="parking.payment_required" class="parking-clock" @click="showTooltip('tlt-d-' + index)">
                    <div class="icon-card-grey"></div>
                    <div style="white-space: nowrap">
                      00 min / 00,00
                    </div>
                    <div class="icon-info-circle"></div>
                  </div>
                  <el-button class="parking__button el-button btn el-button--default btn--change" :disabled=false
                    @click="(!user.paymentModuleEnabled || !parking.payment_required) ? startGuestParking(parking.id) : startPayment(parking.id)"><span
                      class="icon-parking-start-w">{{ $t('end_user.startParking') }}</span>
                  </el-button>
                </div>
              </td>
            </tr>
          </table>

          <!-- mobile version -->

          <div class="parking__list" v-else>
            <div class="parking__item" v-for="(parking, index) in parkings" :key="index">
              <div class="parking__name">
                <div class="parking__text d-flex">
                  <div v-if="user.paymentModuleEnabled">
                    <div v-if="parking.payment_required" class="payment-requirement paid">
                      <i class="parking__icon icon-parking-paid"></i>
                    </div>
                    <div v-else class="payment-requirement free">
                      <i class="parking__icon icon-parking-free"></i>
                    </div>
                  </div>
                  <div v-else>
                    <div class="payment-requirement free">
                      <i class="parking__icon icon-parking-free"></i>
                    </div>
                  </div>
                  <div style="line-height: 40px;">{{ parking.name }}</div>
                </div>
              </div>
              <div class="parking__buttons parking__col--buttons">

                <!-- running guest parking [mobile] -->

                <div v-if="parking.parkings.length > 0" class="parking-buttons">
                  <div v-for="(parked, p_index) in parking.parkings" :key="p_index">
                    <div class="run-parking-data">
                      <div class="car-number">
                        <div class="icon-car-grey"></div>
                        <div>{{ parked.vehicle_reg }}</div>
                      </div>
                      <div class="parking-clock">
                        <div class="icon-clock-grey"></div>
                        <div>{{ getTime(parked.start_time) }} >> {{ getTime(parked.end_time) }}</div>
                      </div>
                      <div>
                        <tooltip2 :id="'tlt-mr-' + index" :ref="'tlt-' + index" class="tooltip2"
                          style="visibility: hidden">
                          <PricingRulesInfo :price-rules="parking.pricing_rules" />
                        </tooltip2>
                        <div v-if="parking.payment_required" @click="showTooltip('tlt-mr-' + index)"
                          class="parking-clock d-flex">
                          <div class="icon-card-grey"></div>
                          <ParkingCostInfo :price-rules="parking.pricing_rules" :active-parking="parking.parkings" />
                          <div class="icon-info-circle"></div>
                        </div>
                      </div>
                    </div>
                    <el-button class="parking__button el-button btn parking__button-stop el-button--danger"
                      @click="confirmToStopGuestParking(parked.id, parking.id)">
                      <span class="icon-parking-stop-w">{{ $t('end_user.stopParking') }}</span>
                    </el-button>
                  </div>
                </div>

                <!-- not started guest parking [mobile] -->

                <div v-else class="parking-buttons">
                  <div style="padding: 5px 0 15px 5px" v-if="hasSteps(parking.pricing_rules)">
                    <tooltip2 :id="'tlt-m-' + index" :ref="'tlt-' + index" class="tooltip2" style="visibility: hidden">
                      <PricingRulesInfo :price-rules="parking.pricing_rules" />
                    </tooltip2>
                    <div v-if="parking.payment_required" class="parking-clock d-flex"
                      @click="showTooltip('tlt-m-' + index)">
                      <div class="icon-card-grey"></div>
                      <div style="white-space: nowrap; align-self: center">
                        00 min / 00,00
                      </div>
                      <div class="icon-info-circle"></div>
                    </div>
                  </div>
                  <el-button class="parking__button el-button btn el-button--default btn--change d-flex" :disabled=false
                    @click="(!user.paymentModuleEnabled || !parking.payment_required) ? startGuestParking(parking.id) : startPayment(parking.id)">
                    <span class="icon-parking-start-w">{{ $t('end_user.startParking') }}</span>
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  choose card for payment modal window  -->

      <ConfirmationModal v-if="cardListModal.show" :confirmText="$t('end_user.startParking')"
        @cancel="closeCardListModal" @confirmed="startGuestParking(currentParkingId)">
        <h1 slot="header">{{ $t('payment.choose_a_card') }}</h1>
        <div slot="body" v-for="(card, index) in cards" :key="index">
          <div class="d-flex cardList form__field form__field_radio" style="cursor: pointer;"
            @click="setCardDefault(card.id)">
            <div class="radio">
              <input type="radio" name="radiobtn" :id="card.id" :value="card.id"
                :checked="(!card.is_default && paymentMethod === card.id) || (card.is_default && (paymentMethod === '' || paymentMethod === card.id))">
            </div>
            <div class="method">{{ card.payment_method }} {{ card.masked_pan.substr(card.masked_pan.length - 7) }}</div>
            <div class="name">{{ card.name }}</div>
          </div>
        </div>
      </ConfirmationModal>

      <!--  confirm stop parking modal window  -->

      <ConfirmationModal v-if="showPromptToStopParking" :confirmText="$t('common.confirm')"
        @cancel="promptToStopParking(false)" @confirmed="stopGuestParking()">
        <h1 slot="header">{{ $t('payment.confirm_to_stop_parking') }}</h1>
      </ConfirmationModal>

      <!-- stopped parking short report -->

      <WarningModal v-if="this.stopParkingReport.show" @close="() => this.stopParkingReport.show = false">
        <h1 slot="header">{{ $t(this.stopParkingReport.header) }}</h1>
        <div slot="body" class="stop-report-data">
          <div class="main-info">
            <div>
              {{ this.stopParkingReport.body.sale_date }}
              <span class="product-name">{{ this.stopParkingReport.body.data_location }}</span>
            </div>
            <div class="car-number">
              <div class="icon-car-grey"></div>
              <div>{{ this.stopParkingReport.body.vehicle_reg }}</div>
            </div>
            <div>{{ this.stopParkingReport.body.start_parking }} - {{ this.stopParkingReport.body.stop_parking }}</div>
          </div>
          <div class="total-sum">
            {{ $t('common.total') }}: {{ this.stopParkingReport.body.total_sum }}
          </div>
          <div>{{ this.stopParkingReport.body.issuer }} {{ this.stopParkingReport.body.billed_from }}</div>
        </div>
      </WarningModal>

      <!--  Error messages    -->

      <WarningModal v-if="errorWarningShow" @close="() => errorWarningShow = false">
        <h1 slot="header">{{ $t('common.error') }}</h1>
        <div slot="body" class="stop-report-data">
          <div class="main-info">
            {{ $t('errors.' + this.errorMessage) }}
          </div>
        </div>
      </WarningModal>

    </div>
    <div v-else class="loader-bubbles"></div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Tooltip from './../common/Tooltip';
import Tooltip2 from './../common/Tooltip2';
import moment from 'moment/moment';
import ConfirmationModal from './../common/ConfirmationModal';
import { sanitizeVehicleRegNumber } from '../../utils';
import store from "../../store";
import WarningModal from './../common/WarningModal'
import ListModal from './../common/ListModal';
import PricingRulesInfo from '../pricingrules/product/PricingRulesInfo'
import ParkingCostInfo from '../pricingrules/product/ParkingCostInfo'

export default {
  components: {
    Tooltip,
    Tooltip2,
    ConfirmationModal,
    WarningModal,
    ListModal,
    PricingRulesInfo,
    ParkingCostInfo
  },
  data() {
    return {
      currency_short: process.env.CURRENCY_SHORT,
      date_time_format: 'DD.MM.YYYY HH:mm',
      window: {
        width: window.innerWidth,
      },
      form: {
        vehicleReg: '',
      },
      parkings: [],
      vehicleRegError: false,
      paymentMethod: '',
      radioChecked: '',
      currentParkingId: '',
      showPromptToStopParking: false,
      stopParkingId: 0,
      stopProductId: 0,
      stopParkingReport: {
        show: false,
        header: 'payment.parking_completed',
        body: {
          sale_date: '',
          data_location: '',
          vehicle_reg: '',
          start_parking: '',
          stop_parking: '',
          total_sum: 0,
          billed_from: '',
          issuer: ''
        }
      },
      showSection: true,
      toggleIconDown: 'icon icon-bl-arrow-down',
      toggleIconUp: 'icon icon-bl-arrow-up',
      errorWarningShow: false,
      errorMessage: null
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/user/user',
      users: 'users/user/user',
      vehicles: 'users/vehicles/vehicles',
      vehicleError: 'users/vehicles/error',
      parkingsStore: 'users/guestParkings/parkings',
      isLoading: 'users/guestParkings/isLoading',
      inProgress: 'payment/cards/inProgress',
      pricingrules: 'pricingrules/pricingrules/pricingrules',
      cards: 'payment/cards/cardList',
      cardListModal: 'users/guestParkings/cardListModal',
      error: 'users/guestParkings/error'
    }),
  },
  mounted() {
    this.fetchAllData()
    if (document.cookie.match(new RegExp('VehicleReg=([^;]+)'))) {
      this.form.vehicleReg = document.cookie.match(new RegExp('VehicleReg=([^;]+)'))[1];
    }
  },
  methods: {
    showTooltip(tltId) {
      let priceTooltip = document.getElementById(tltId)
      priceTooltip.style.visibility === 'hidden'
        ? priceTooltip.style.visibility = 'visible'
        : priceTooltip.style.visibility = 'hidden'
    },
    getTime(time) {
      return moment(time).format('DD.MM HH:mm');
    },
    fetchAllData() {
      this.fetchUser();
    },
    fetchUser() {
      if (this.user.data.selectedRole.id) {
        this.$store.dispatch('users/guestParkings/setIsLoading', true)
        this.$store.dispatch('users/user/fetch', { id: this.user.data.selectedRole.id, user: this.user }).then(() => {
          this.getPaymentCards()
          this.fetchGuestParkings();
        });
      }
    },
    fetchGuestParkings() {
      if (this.user && this.users.partner) {
        this.$store.dispatch('users/guestParkings/fetch', { user: this.user, partner: this.users.partner[0] })
          .then(() => {
            this.parkings = this.parkingsStore.body.data
          }).finally(() => {
            this.$store.dispatch('users/guestParkings/setIsLoading', false)
          });
      } else {
        this.$store.dispatch('users/guestParkings/setIsLoading', false)
      }
    },
    addVehicleRegToCookies() {
      this.form.vehicleReg = sanitizeVehicleRegNumber(this.form.vehicleReg);
      document.cookie = `VehicleReg = ${this.form.vehicleReg}`;
    },
    focusedVehicleReg() {
      this.vehicleRegError = false;
    },
    startGuestParking(parking_id) {
      if (!this.isAllowed) {
        return false
      }
      if (!this.form.vehicleReg) {
        this.vehicleRegError = true
        return false
      }

      this.$store.dispatch('users/guestParkings/setIsLoading', true)
      this.$store.dispatch('users/guestParkings/startGuestParking', {
        data: {
          vehicle_reg: this.form.vehicleReg,
          payment_method: this.paymentMethod
        },
        parking_id: parking_id
      }).then(() => {
        if (this.error) {
          this.errorWarningShow = true
          this.errorMessage = this.error.body.message
        }
        this.closeCardListModal()
        this.fetchGuestParkings();
      }).catch((error) => {
        this.$store.dispatch('users/guestParkings/setIsLoading', false)
      })
    },
    confirmToStopGuestParking(parking_id, product_id) {
      this.stopParkingId = parking_id
      this.stopProductId = product_id
      this.promptToStopParking(true)
    },
    stopGuestParking() {
      this.promptToStopParking(false)
      this.$store.dispatch('users/guestParkings/setIsLoading', true)
      this.$store.dispatch('users/guestParkings/stopGuestParking', {
        parking_id: this.stopParkingId,
        product_id: this.stopProductId
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }
          this.showReport(response.data.data)
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$store.dispatch('users/guestParkings/setIsLoading', false)
        });
    },
    showReport(reportData) {
      this.errorMessage = null
      if (reportData.transaction && reportData.transaction.state === 'failed') {
        this.errorMessage = 'payment_failed'
        this.errorWarningShow = true
      } else {
        this.showStopParkingReport(reportData)
      }
      this.fetchGuestParkings();
    },
    showStopParkingReport(reportData) {

      const isTransaction = reportData.transaction && reportData.transaction.payment_method

      this.stopParkingReport.body = {
        start_parking: moment(reportData.start_time).format(this.date_time_format),
        stop_parking: moment(reportData.end_time).format(this.date_time_format),
        vehicle_reg: reportData.vehicle_reg ? reportData.vehicle_reg : '-',
        data_location: reportData.product ? reportData.product.name : '-',
        total_sum: isTransaction ? reportData.transaction.amount : '0,00 ' + this.currency_short,
        sale_date: isTransaction ? reportData.transaction.sale_date : null,
        issuer: isTransaction ? reportData.transaction.payment_method.issuer : null,
        billed_from: isTransaction ? reportData.transaction.payment_method.masked_pan.substr(
          reportData.transaction.payment_method.masked_pan.length - 7) : null
      }
      this.stopParkingReport.show = true
    },
    startPayment(parking_id) {
      if (!this.isAllowed) {
        return false
      }
      if (!this.form.vehicleReg) {
        this.vehicleRegError = true
        return false
      }

      // show modal to choose 1 card
      if (this.cards.length > 0) {
        this.cards.forEach((card, index) => {
          if (card.is_default) {
            this.paymentMethod = card.id
          }
        })
        this.currentParkingId = parking_id
        store.dispatch('users/guestParkings/showCardListModal', true)
      }
      // redirect to add card page
      else if (this.cards.length === 0) {
        window.location.href = `${process.env.BASE_URL}payment`
      } else {
        // start parking with defined payment method
        this.paymentMethod = this.cards[0].id
        this.startGuestParking(parking_id)
      }

    },
    isAllowed() {
      if (this.form.vehicleReg.length === 0) {
        this.vehicleRegError = true;
        this.$refs.tooltip.$refs.tooltip.style.visibility = 'visible';
        return false
      }
      return this.user.data;
    },
    closeCardListModal() {
      store.dispatch('users/guestParkings/showCardListModal', false)
    },
    setCardDefault(id) {
      this.paymentMethod = id
    },
    getPaymentCards() {
      if (this.user.paymentModuleEnabled && this.isLoading) {
        this.$store.dispatch('payment/cards/fetchUserCardList')
      }
    },
    promptToStopParking(visibility) {
      this.showPromptToStopParking = visibility
    },
    toggleSection() {
      this.showSection = !this.showSection
    },
    hasSteps(priceRules) {
      let ret = false;
      priceRules.forEach(el => {
        if (el.steps.length > 0) {
          ret = true
        }
      })
      return ret
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/app.scss";
@import '~styles/_mixins.scss';

.icon {
  width: 28px !important;
  height: 28px !important;
}

h1 {
  font-size: larger;
}

.active-parking {
  background-color: white;
}

.parking-info {
  line-height: 40px;
  background-color: var(--grey-four);
  border-radius: 5px;
  padding-left: 15px;
  align-self: center;
  cursor: pointer;
  flex-basis: 100%;
}

.car-number {
  display: flex;
  justify-content: center;
  font-weight: bolder;
  margin-right: 15px;

  .icon-car-grey {
    height: 16px;
    width: 16px;
    margin-right: 7px;
    align-self: center;
  }
}

.stop-report-data {
  .car-number {
    line-height: 20px;

    .icon-car-grey {
      height: 17px;
    }
  }
}

.parking-clock {
  display: flex;
  margin-right: 20px;

  .icon-clock-grey {
    align-self: center;
    height: 16px;
    width: 16px;
    margin-right: 7px;
  }

  .icon-card-grey {
    align-self: center;
    height: 16px;
    width: 16px;
    margin-right: 10px;
  }

  .icon-info-circle {
    align-self: center;
    width: 28px;
    height: 28px;
    margin-left: 10px;
    cursor: pointer;
  }
}


.stop-report-data {
  .product-name {
    font-size: larger;
    font-weight: bolder;
  }

  .main-info {
    margin: 5px 10px;
    background-color: #F8F9F9;
    padding: 10px;

    div {
      margin: 7px 5px;
    }
  }

  .total-sum {
    margin: 20px;
    font-size: x-large;
    font-weight: bolder;
  }
}

.cardList div {
  padding: 10px;
}

div.radio {
  width: 10%;
}

div.method {
  width: 45%;
  text-align: center;
}

div.name {
  width: 45%;
  text-align: left;
  overflow: hidden
}

.cardList:hover {
  background-color: var(--brand-blue);
  color: white;
}

.details-component {
  &__header {
    //justify-content: flex-start;
    height: auto;
    padding-bottom: 3px;
  }
}

.number-change {
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;

  .el-input {
    border-spacing: 0;
    position: relative;

    &__inner {
      &--vehicle-reg {
        position: relative;
        width: fit-content;
        height: 40px;

        @media screen and (max-width: 760px) {
          width: 100%;
        }
      }
    }
  }
}

.parking-name-container,
.occupancy-cell {
  border-bottom: none !important;
}

.occupancy-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.occupancy-details-container {
  width: 42px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 5px;
  border-radius: 6px;
}

.sessions-count {
  background-color: #1EE8CA;
}

.sessions-count-icon {
  width: 16px;
  height: 16px;
  background: url('~icons/park-free-16.svg') left center no-repeat;
}

.max-sessions {
  background-color: #FFD0D0;
}

.max-sessions-icon {
  width: 16px;
  height: 16px;
  background: url('~icons/park-occupied-16.svg') left center no-repeat;
}

.btn {
  display: inline-flex;
  width: 100%;
  height: auto;
  text-transform: uppercase;
  padding: 9px 15px;
  line-height: 1.15;
  vertical-align: top;
  margin-left: 2px;
  font-size: 16px;
  word-break: break-word;
  white-space: pre-line;

  & span {
    width: auto !important;
  }

  &--change {
    background-color: var(--brand-green);
    color: var(--white);
  }

  &.is-disabled {
    color: var(--black);
    text-align: start;
  }

  @media screen and (max-width: 760px) {
    font-family: 'Geogrotesque Md', sans-serif;
    font-weight: bold;
    max-height: none;
  }
}

.header {
  margin: 0;
}

.details-table {
  &__row {
    .el-button {
      padding: 0;
      height: 38px;
      vertical-align: middle;

      span {
        margin: 0;
      }
    }

    .btn {
      &--change {
        display: inline-flex;
        text-transform: uppercase;
        background-color: var(--brand-green);
        color: var(--white);
        padding: 10px 15px;
        vertical-align: top;

        span {
          width: auto !important;
        }
      }
    }

    .el-select {
      width: 100%;
      position: relative;

      input {
        padding-right: 54px;
      }

      i {
        z-index: 2;
        color: #878d99;
      }
    }

    .el-input {
      &__suffix {
        z-index: 2;
        right: 0;
      }
    }

    .tooltip {
      top: 50%;
      right: auto;
      left: 50px;
      z-index: 2000;
      transform: translateY(-50%);
      max-height: none;

      &__content {
        @media screen and (max-width: 1000px) {
          max-height: none;
          height: auto;
          white-space: pre-wrap;
          max-width: 150px;
        }
      }
    }

    .tooltip.to-bottom {
      top: auto;
      bottom: 16px;
      transform: none;
    }

    .el-tag {
      background-color: #f5f7fa;
      border: 1px solid #f5f7fa;
      margin: 2px;
      height: 40px;
      line-height: 40px;
      padding: 0 10px 0 15px;
      color: var(--black);
      cursor: pointer;

      /deep/ &__close {
        color: var(--black);
        margin-right: 8px;
        top: 0;
        font-size: large;
      }

      &__close:hover {
        background-color: transparent;
      }

      &.el-tag--success {
        background-color: var(--brand-green);
        border: 1px solid var(--brand-green);
        color: white;

        /deep/ .el-tag__close {
          color: white;
        }

        &.el-tag--permit /deep/ .el-tag__close {
          &::before {
            background: url('~icons/number-permit.svg') center/contain no-repeat;
          }
        }
      }

      &.el-tag--permit /deep/ .el-tag__close {
        width: 30px;
        height: 100%;
        margin-right: 0;

        &::before {
          content: '';
          background: url('~icons/number-permit-black.svg') center/contain no-repeat;
          height: 100%;
        }
      }
    }

    .el-tag:nth-last-child(2) {
      margin-right: -1px;
    }

    .el-input input {
      text-transform: uppercase;
    }
  }

  &__row:nth-child(2) {
    .el-input {
      margin: 2px;
    }

    .details-table__col {
      >.el-button {
        position: relative;
        padding: 10px 69px 10px 15px;
        border-color: #d8dce5;
        height: auto;
        max-width: 300px;
        margin: 2px;

        span {
          white-space: pre-line;
          line-height: 20px;

          i {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 54px;
            border-left: 1px solid #d8dce5;
            margin-left: 15px;
            vertical-align: top;
            background-color: #f5f7fa;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }

          i:before {
            position: absolute;
            right: 50%;
            top: 50%;
            transform: translate(50%, -50%);
            color: #97a8be;
          }
        }
      }
    }
  }
}

.details-table__row--vehicle {
  display: block;
  height: auto;
  border: none;
  padding: 0 50px;

  @media screen and (max-width: 760px) {
    padding: 0;
  }

  .details-table__col--vehicle {
    display: flex;
    flex-direction: column;
    padding: 0;

    .el-tag {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      width: calc(100% - 4px);

      &.el-tag--success {
        background-color: var(--brand-green);
        border: 1px solid var(--brand-green);
        color: white;

        /deep/ .el-tag__close {
          color: white;
        }

        &.el-tag--permit /deep/ .el-tag__close {
          &::before {
            background: url('~icons/number-permit.svg') center/contain no-repeat;
          }
        }
      }

      &.el-tag--permit /deep/ .el-tag__close {
        width: 30px;
        height: 100%;

        &::before {
          content: '';
          background: url('~icons/number-permit-black.svg') center/contain no-repeat;
          height: 100%;
        }
      }

      @media screen and (max-width: 760px) {
        font-size: large;
        height: 60px;
      }
    }

    .vehicle-input {
      max-width: 100%;
      height: 40px;

      @media screen and (max-width: 760px) {
        font-size: large;
        height: 60px;
      }
    }

    .el-input-group {
      @media screen and (max-width: 760px) {
        font-size: large;
        height: 60px;

        /deep/ input {
          height: 60px;
        }
      }
    }
  }
}

.parking {
  &__table {
    margin-top: 20px;
    width: 100%;
    border-spacing: 0;

    @media screen and (max-width: 760px) {
      border-spacing: 0 10px;
      margin: 0;
      width: 100%;
    }
  }

  &__row {
    &--header {
      &::after {
        content: '';
        position: absolute;
        top: 45px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: var(--brand-orange);
      }
    }
  }

  &__col {
    //margin-left: 20px;
    padding: 7px 0;
    border-bottom: 1px solid #cccccc;

    &--buttons {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 4px;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__item {
    margin: 15px 0;
  }

  &__name {
    display: flex;
    align-items: center;
    margin: 0 0 10px;
  }

  &__icon {
    display: block;
    width: 40px;
    height: 40px;

    @media screen and (max-width: 760px) {
      margin-right: 10px;
      align-self: flex-start;
    }
  }

  &__text {
    font-family: 'Geogrotesque Md', sans-serif;
    font-size: 24px;
    font-weight: bold;
    color: var(--black);
    margin: 0;
  }

  &__button {
    transition: all 200ms ease-in-out;

    &:hover {
      opacity: 0.7;
    }

    &.is-disabled {
      &:hover {
        opacity: 1;
      }
    }
  }

  &__buton-text-start {
    text-align: start;
  }

  &__buton-text-no-wrap {
    white-space: nowrap;
  }

  &__button-stop {
    background-color: var(--brand-red);
    box-shadow: 0 4px 4px 0 rgba(173, 181, 189, 0.2);
    transition: all 200ms ease-in-out;

    &:hover {
      opacity: 0.7;
    }
  }

  .run-parking-data {
    padding: 15px 10px;
    border-radius: 5px;
    margin: 0 3px 15px 5px;
    background-color: var(--grey-four);
  }

  @media screen and (max-width: 760px) {
    .parking-details-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }

    .parking-name-container {
      display: flex;
      align-items: center;
    }

    .parking-button-container {
      padding-right: 10px;
      flex-basis: 100%;
    }

    .occupancy-data-container {
      display: flex;
      align-items: center;
      gap: 25px;
    }

    .parking-buttons {
      width: 100%;
    }

    .parking__item {
      background-color: white;
      padding: 10px
    }

    .run-parking-data {
      padding: 15px 10px;
      border-radius: 5px;
      margin: 0 3px 15px 5px;
      background-color: var(--grey-four);

      .car-number {
        justify-content: left;
        margin-bottom: 10px;

        .icon-car-grey {
          height: 16px;
          width: 16px;
          margin-right: 10px;
        }
      }

      .parking-clock {
        display: flex;
        margin-bottom: 5px;

        .icon-clock-grey {
          height: 16px;
          width: 16px;
          margin-right: 10px;
        }
      }
    }
  }

  @media screen and (min-width: 760px) {
    .parking-details-container {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #cccccc;
    }

    .parking-info {
      flex-basis: initial;
    }

    .parking-name-container {
      display: flex;
      align-items: center;
    }

    .occupancy-cell {
      display: flex;
      align-items: center;
      margin-right: auto;
      margin-left: 50px;
    }

    .occupancy-details {
      flex-direction: row;
    }

    .parking-button-container {
      border-bottom: none;
    }
  }
}

.vehicleReg-container {
  position: relative;
  display: flex;
  align-items: center;
}

.vehicleReg-tooltip {
  right: auto;
  left: 204px;

  @media screen and (max-width: 760px) {
    left: 0 !important;
    top: auto !important;
    bottom: 50px !important;
    transform: translateY(0) !important;

    &:after {
      left: 50%;
      top: auto;
      bottom: -13px;
      transform: rotate(270deg);
    }
  }
}

.tooltip__content {
  max-width: 100%;
}

.payment-requirement {
  font-size: 13px;
}

.payment-requirement.free {
  color: var(--grey-one)
}

.payment-requirement.paid {
  color: var(--brand-blue)
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/SelectGuestParking.vue